import { render, staticRenderFns } from "./BosADivider.vue?vue&type=template&id=5ce77905&scoped=true"
import script from "./BosADivider.vue?vue&type=script&lang=js"
export * from "./BosADivider.vue?vue&type=script&lang=js"
import style0 from "./BosADivider.vue?vue&type=style&index=0&id=5ce77905&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce77905",
  null
  
)

export default component.exports